import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M0 32L0 0L45.4492 0L56 16L45.4492 32L0 32ZM46.417 16L41.1416 8L8 8V24L41.1416 24L46.417 16Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 32

/**
 * Tag Right cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const TagRightCutoutShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default TagRightCutoutShape
